(function () {
  var STORE = 'cm_params';
  var skip = {
    variant: 1,
    page: 1,
    sort_by: 1,
    q: 1,
    query: 1,
    type: 1,
    constraint: 1,
    section_id: 1,
    oseid: 1,
    key: 1,
    return_to: 1,
    pb: 1
  };

  function keep(key) {
    if (!key || skip[key]) return false;
    if (key.charAt(0) === '_') return false;
    if (key.indexOf('filter.') === 0) return false;
    return true;
  }

  function readStore() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeStore(params) {
    try {
      sessionStorage.setItem(STORE, JSON.stringify(params));
    } catch (error) {}
  }

  var saved = readStore();
  new URLSearchParams(window.location.search).forEach(function (value, key) {
    if (keep(key)) saved[key] = value;
  });
  writeStore(saved);

  function applyToUrl(href) {
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return href;
    }
    if (url.origin !== window.location.origin) return href;
    Object.keys(saved).forEach(function (key) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, saved[key]);
    });
    return url.pathname + url.search + url.hash;
  }

  var here = new URL(window.location.href);
  var changed = false;
  Object.keys(saved).forEach(function (key) {
    if (!here.searchParams.has(key)) {
      here.searchParams.set(key, saved[key]);
      changed = true;
    }
  });
  if (changed) {
    history.replaceState(history.state, '', here.pathname + here.search + here.hash);
  }

  function stamp(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      var next = applyToUrl(href);
      if (next !== href) link.setAttribute('href', next);
    });
  }

  function start() {
    stamp(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var next = applyToUrl(href);
    if (next !== href) link.setAttribute('href', next);
  }, true);

  if (window.MutationObserver && document.body) {
    var frame = 0;
    var observer = new MutationObserver(function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        stamp(document);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
